module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19Rx7QV/tc-custom/9781035853182.jpg?1718106148006",
      "alt": "This image is the cover for the book The Woodhouse Mystery"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Woodhouse Mystery\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A cold case comes back to haunt the small town of Valley-Wood. We follow the life of Brendan Gibbons who returns to reconnect with old friends. The townsfolk live a life of quiet effort until it is upturned by outsiders and innuendo. Secrets are being unveiled and catastrophic events lead to a mysterious death that adds a layer of fear and tension. "), _c('br'), _vm._v("At the foot of the town rests The Woodhouse Lodge on the bank of the fast-flowing Nugget River. The Lodge is a magnet with rafters from the city for the thrill of running white-water rapids. Tangled relationships thread their way through the ever-changing realignments of loyalties. "), _c('br'), _vm._v("Vivid characters reveal the truth as strange happenings tear the fabric of old friendships. It’s a drifting tale of suspenseful moments with no sure footing, until strength and hope shimmer on the horizon.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John R. Christensen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John R. Christensen is a Canadian author of six novels. In his professional life, he was an executive life strategist. He uses his knowledge of the intricacies of relationships and communication to illuminate his vivid characters and creative arc of his story lines. He lives with his wife, Hazel in Burlington, Ontario, Canada.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0